const SkeletonLoader = ({width, height}) => {

    let skeletonStyle = {
        width: width,
        height: height
    };
    return (
        <span className="skeleton-box" style={skeletonStyle}/>
    )
};

export default SkeletonLoader;